export const regexIsMatch = (key: string, expressions: string[]) => {
  return expressions.some((exp: string) => new RegExp(exp).test(key));
};
